export const audioPlayIcon = `
<svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11.3828 6.42041C11.7159 6.61291 11.7159 7.09318 11.3828 7.28564L1.24805 13.1372C0.914745 13.3296 0.49813 13.0894 0.498046 12.7046L0.498047 1.00146C0.498047 0.616564 0.914714 0.376397 1.24805 0.568847L11.3828 6.42041Z"
    fill="var(--zbp-svg-primary-color, black)"
    stroke="var(--zbp-svg-primary-color, black)"
  />
</svg>
`;
